import { getCalculatedPercentValueDependOnSettings } from 'partner360/helpers/financialTable/getCalculatedPercentValueDependOnSettings'
import { getCalculatedValueDependOnSettings } from 'partner360/helpers/financialTable/getCalculatedValueDependOnSettings'
import { getGroupedSobCompetitors } from 'partner360/helpers/getGroupedSobCompetitors'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'
import { ISobCompetitor } from 'partner360/models/ISobCompetitor'
import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

interface ICollectSobDataDependsOnSettings {
  currency: string
  rounding?: QBRRounding
  netNdp: ActualsValueTypes
  sobCompetitors: ISobCompetitor[]
}
export const collectSobDataDependsOnSettings = ({
  currency,
  netNdp,
  rounding = QBRRounding.AsIs,
  sobCompetitors,
}: ICollectSobDataDependsOnSettings) => {
  const getValue = getCalculatedValueDependOnSettings<ISobCompetitor>({
    currency,
    rounding,
    netNdp,
  })
  const getPercent = getCalculatedPercentValueDependOnSettings<ISobCompetitor>({
    currency,
    netNdp,
  })

  const sortedSobCompetitors = [...sobCompetitors].sort((a, b) => {
    const orderA = a.SortOrder ?? Number.POSITIVE_INFINITY
    const orderB = b.SortOrder ?? Number.POSITIVE_INFINITY
    return orderA - orderB
  })
  return getGroupedSobCompetitors({ data: sortedSobCompetitors, getValue, getPercent })
}
